import { PackageOrder } from '../types';
import { normalizeMigrosStatus } from './migrosStatus';

export interface StatusButtonInfo {
  label: string;
  emoji: string;
  disabled: boolean;
  color: string;
  nextStatus: string | null;
}

export function getStatusButtonInfo(
  selectedOrder: PackageOrder | null,
  getirCountdownMap: Record<string | number, number>
): StatusButtonInfo {
  if (!selectedOrder) {
    return { label: 'DURUM', emoji: '⏳', disabled: true, color: 'grey.400', nextStatus: null };
  }

  const isSignalROrder = ['qr', 'ecommerce', 'kiosk'].includes(selectedOrder.source);

  if (isSignalROrder) {
    switch (selectedOrder.status) {
      case 'new':
        return { label: 'HAZIR YAP', emoji: '✅', disabled: false, color: 'success.main', nextStatus: 'READY' };
      case 'ready':
        return { label: 'TESLİM ET', emoji: '📦', disabled: false, color: 'info.main', nextStatus: 'DELIVERED' };
      case 'delivered':
        return { label: 'TESLİM EDİLDİ', emoji: '✅', disabled: true, color: 'grey.400', nextStatus: null };
      case 'cancelled':
        return { label: 'İPTAL', emoji: '❌', disabled: true, color: 'grey.400', nextStatus: null };
      default:
        return { label: 'HAZIR YAP', emoji: '✅', disabled: false, color: 'success.main', nextStatus: 'READY' };
    }
  }

  if (selectedOrder.source === 'getir' && selectedOrder.getirStatus !== undefined) {
    const gs = selectedOrder.getirStatus;
    const isRestoranGetirsin = selectedOrder.deliveryType === 2;

    const orderCountdown = getirCountdownMap[selectedOrder.id] || 0;
    const isCountdownActive = orderCountdown > 0;

    if (gs === 1500 || gs === 1600) {
      return { label: 'İPTAL', emoji: '❌', disabled: true, color: 'grey.400', nextStatus: null };
    }
    if (gs >= 900) {
      return { label: 'TESLİM EDİLDİ', emoji: '✅', disabled: true, color: 'grey.400', nextStatus: null };
    }

    if (isRestoranGetirsin && gs >= 700) {
      return { label: isCountdownActive ? `TESLİM ET (${orderCountdown}s)` : 'TESLİM ET', emoji: '✅', disabled: isCountdownActive, color: isCountdownActive ? 'grey.500' : 'success.main', nextStatus: 'DELIVER' };
    }

    if (isRestoranGetirsin && gs >= 550) {
      const hasCourier = !!selectedOrder.courierName
        && !selectedOrder.courierName.toLowerCase().includes('restorankuryesi')
        && selectedOrder.courierName.toLowerCase() !== 'restoran kuryesi';
      if (hasCourier) {
        return { label: isCountdownActive ? `TESLİM ET (${orderCountdown}s)` : 'TESLİM ET', emoji: '✅', disabled: isCountdownActive, color: isCountdownActive ? 'grey.500' : 'success.main', nextStatus: 'DELIVER' };
      } else {
        return { label: isCountdownActive ? `KURYE ATA (${orderCountdown}s)` : 'KURYE ATA', emoji: '🛵', disabled: isCountdownActive, color: isCountdownActive ? 'grey.500' : 'info.main', nextStatus: 'DELIVER_WITH_COURIER' };
      }
    }

    if (gs >= 700) {
      return { label: 'YOLDA', emoji: '🛵', disabled: true, color: 'info.main', nextStatus: null };
    }
    if (gs >= 600) {
      return { label: 'KURYEDE', emoji: '🛵', disabled: true, color: 'info.main', nextStatus: null };
    }
    if (gs >= 550) {
      return { label: isCountdownActive ? `KURYEYE VER (${orderCountdown}s)` : 'KURYEYE VER', emoji: '🛵', disabled: isCountdownActive, color: isCountdownActive ? 'grey.500' : 'info.main', nextStatus: 'HANDOVER' };
    }
    if (gs >= 500) {
      return { label: isCountdownActive ? `HAZIRLA (${orderCountdown}s)` : 'HAZIRLA', emoji: '👨‍🍳', disabled: isCountdownActive, color: isCountdownActive ? 'grey.500' : 'warning.main', nextStatus: 'PREPARE' };
    }
    return { label: isCountdownActive ? `ONAYLA (${orderCountdown}s)` : 'ONAYLA', emoji: '✅', disabled: isCountdownActive, color: isCountdownActive ? 'grey.500' : 'success.main', nextStatus: 'VERIFY' };
  }

  if (selectedOrder.source === 'migros' && selectedOrder.migrosStatus) {
    // Ham statü yerine kanonik değer: Migros okuma sözlüğündeki statüler
    // (COLLECTING, COLLECTION_APPROVED, IN_DELIVERY, DELIVERED) aşağıdaki
    // dallara girmediği için onaylanmış siparişe tekrar ONAYLA gösteriliyordu.
    const ms = normalizeMigrosStatus(selectedOrder.migrosStatus);
    const isRestaurantCourier = selectedOrder.migrosDeliveryProvider === 'RESTAURANT';

    if (ms === 'COMPLETED') {
      return { label: 'TESLIM EDILDI', emoji: '', disabled: true, color: 'grey.400', nextStatus: null };
    }
    if (ms === 'REJECTED' || ms === 'CANCELLED') {
      return { label: 'IPTAL', emoji: '', disabled: true, color: 'grey.400', nextStatus: null };
    }
    if (ms === 'DELIVERY') {
      if (isRestaurantCourier) {
        return { label: 'TESLIM ET', emoji: '', disabled: false, color: 'success.main', nextStatus: 'Completed' };
      }
      return { label: 'YOLDA', emoji: '', disabled: true, color: 'info.main', nextStatus: null };
    }
    if (ms === 'PREPARED') {
      if (isRestaurantCourier) {
        const hasCourier = !!selectedOrder.courierName && selectedOrder.courierName !== 'Migros Kurye';
        if (hasCourier) {
          return { label: 'YOLA CIK', emoji: '', disabled: false, color: 'info.main', nextStatus: 'Delivery' };
        }
        return { label: 'KURYE ATA', emoji: '', disabled: false, color: 'info.main', nextStatus: 'MIGROS_ASSIGN_COURIER' };
      }
      return { label: 'HAZIR', emoji: '', disabled: true, color: 'grey.400', nextStatus: null };
    }
    if (ms === 'APPROVED') {
      return { label: 'HAZIRLA', emoji: '', disabled: false, color: 'warning.main', nextStatus: 'Prepared' };
    }
    if (ms === 'NEW_PENDING') {
      return { label: 'ONAYLA', emoji: '', disabled: false, color: 'success.main', nextStatus: 'Approved' };
    }
    // Statü çözülemedi. Onay isteği göndermek Migros tarafından reddedilir ve
    // kasiyeri "sipariş onaylanmadı" yanılgısına düşürür; işlemi kapatıyoruz.
    return { label: 'DURUM BILINMIYOR', emoji: '', disabled: true, color: 'grey.400', nextStatus: null };
  }

  if (selectedOrder.source === 'trendyol' && selectedOrder.trendyolStatus) {
    const ts = (selectedOrder.trendyolStatus || '').toLowerCase();
    const isStoreDelivery = selectedOrder.trendyolDeliveryType === 'STORE';

    if (ts === 'delivered') {
      return { label: 'TESLİM EDİLDİ', emoji: '✅', disabled: true, color: 'grey.400', nextStatus: null };
    }
    if (ts === 'unsupplied' || ts === 'cancelled' || ts === 'returned') {
      return { label: 'İPTAL', emoji: '❌', disabled: true, color: 'grey.400', nextStatus: null };
    }
    if (ts === 'shipped') {
      if (isStoreDelivery) {
        return { label: 'TESLİM ET', emoji: '✅', disabled: false, color: 'success.main', nextStatus: 'TRD_DELIVERED' };
      }
      return { label: 'TESLİM ET', emoji: '✅', disabled: false, color: 'success.main', nextStatus: 'TRD_DELIVERED' };
    }
    if (ts === 'invoiced') {
      if (isStoreDelivery) {
        return { label: 'YOLA ÇIK', emoji: '🛵', disabled: false, color: 'info.main', nextStatus: 'TRD_SHIPPED' };
      }
      return { label: 'TESLİM ET', emoji: '✅', disabled: false, color: 'success.main', nextStatus: 'TRD_DELIVERED' };
    }
    if (ts === 'picking') {
      return { label: 'HAZIR', emoji: '👨‍🍳', disabled: false, color: 'warning.main', nextStatus: 'TRD_READY' };
    }
    return { label: 'ONAYLA', emoji: '✅', disabled: false, color: 'success.main', nextStatus: 'TRD_ACCEPT' };
  }

  if (selectedOrder.source === 'yemeksepeti' && selectedOrder.yemeksepetiStatus) {
    const ys = (selectedOrder.yemeksepetiStatus || '').toUpperCase();
    const ysOrderType = (selectedOrder.yemeksepetiOrderType || '').toUpperCase();
    const isVendorDelivery = ysOrderType === 'VENDOR_DELIVERY' || (selectedOrder.yemeksepetiExpeditionType || '').toUpperCase() === 'DELIVERY_BY_RESTAURANT';
    // Gel Al: kurye yok, siparişi müşterinin kendisi teslim alır.
    const isPickup = ysOrderType === 'PICKUP' || (selectedOrder.yemeksepetiExpeditionType || '').toUpperCase() === 'PICKUP';

    if (ys === 'DELIVERED' || ys === 'COMPLETED') {
      return { label: 'TESLİM EDİLDİ', emoji: '✅', disabled: true, color: 'grey.400', nextStatus: null };
    }
    if (ys === 'REJECTED' || ys === 'CANCELLED') {
      return { label: 'İPTAL', emoji: '❌', disabled: true, color: 'grey.400', nextStatus: null };
    }
    if (ys === 'PICKED_UP' || ys === 'ON_DELIVERY' || ys === 'DELIVERY') {
      if (isPickup) {
        return { label: 'MÜŞTERİ ALDI', emoji: '🛍️', disabled: true, color: 'success.main', nextStatus: null };
      }
      return { label: 'KURYEDE', emoji: '🛵', disabled: true, color: 'info.main', nextStatus: null };
    }
    if (ys === 'PREPARED' || ys === 'READY') {
      if (isPickup) {
        return { label: 'MÜŞTERİYE VER', emoji: '🛍️', disabled: false, color: 'success.main', nextStatus: 'YS_PICKUP' };
      }
      if (isVendorDelivery) {
        const hasCourier = !!selectedOrder.courierName && selectedOrder.courierName !== 'Yemeksepeti Kurye';
        if (hasCourier) {
          return { label: 'KURYEYE VER', emoji: '🛵', disabled: false, color: 'info.main', nextStatus: 'YS_PICKUP' };
        }
        return { label: 'KURYE ATA', emoji: '🛵', disabled: false, color: 'info.main', nextStatus: 'YS_ASSIGN_COURIER' };
      }
      return { label: 'KURYEYE VER', emoji: '🛵', disabled: false, color: 'info.main', nextStatus: 'YS_PICKUP' };
    }
    if (ys === 'ACCEPTED' || ys === 'CONFIRMED') {
      return { label: 'HAZIRLA', emoji: '👨‍🍳', disabled: false, color: 'warning.main', nextStatus: 'YS_PREPARED' };
    }
    return { label: 'ONAYLA', emoji: '✅', disabled: false, color: 'success.main', nextStatus: 'YS_ACCEPT' };
  }

  switch (selectedOrder.status) {
    case 'new':
      return { label: 'HAZIR YAP', emoji: '✅', disabled: false, color: 'success.main', nextStatus: 'READY' };
    case 'ready':
      return { label: 'KURYE ATA', emoji: '🛵', disabled: false, color: 'info.main', nextStatus: 'ON_DELIVERY' };
    case 'onway':
      return { label: 'TESLİM ET', emoji: '✅', disabled: false, color: 'success.main', nextStatus: 'DELIVERED' };
    case 'delivered':
      return { label: 'TESLİM EDİLDİ', emoji: '✅', disabled: true, color: 'grey.400', nextStatus: null };
    case 'undelivered':
      return { label: 'TESLİM EDİLEMEDİ', emoji: '⚠️', disabled: true, color: 'grey.400', nextStatus: null };
    case 'cancelled':
      return { label: 'İPTAL', emoji: '❌', disabled: true, color: 'grey.400', nextStatus: null };
    default:
      return { label: 'DURUM', emoji: '⏳', disabled: true, color: 'grey.400', nextStatus: null };
  }
}
